<ng-container *transloco="let t; read: 'ime.system.user'">
  <ng-container *ngIf="(allItems$ | async) as allItems; else loading">
    <ng-select #select class="select-sm form-control dropdown-auto-width"
               [items]="allItems"
               [name]="name"
               [searchFn]="searchFn"
               [class.readOnly]="readonly"
               [multiple]="multiple"
               [placeholder]="placeholder"
               [ngModel]="multiple ? entityIds : entityId"
               [groupBy]="groupByRole ? 'Users' : ''"
               [appendTo]="appendTo"
               (ngModelChange)="multiple ? entityIds : entityId = $event"
               (open)="readonly ? select.close() : select.open()"
               (change)="onSelectionChanged($event)"
               bindLabel="DisplayName" bindValue="Id">
      <ng-template ng-footer-tmp>
        <button type="button" *ngIf="entityId && allowEdit" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); editUser()">
          <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#pencil'"></svg>
        </button>
        <button type="button" class="btn btn-sm btn-outline-primary me-1" *ngIf="allowAdd" (click)="select.close(); addNewUser()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        </button>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <button type="button" class="btn btn-sm btn-outline-primary me-1" *ngIf="allowAdd" (click)="select.close(); addNewUser(searchTerm)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
            {{t('Add')}} "{{searchTerm}}"
          </button>
        </div>
      </ng-template>
      <ng-template ng-optgroup-tmp let-item="item">
        {{item.Role}}
      </ng-template>
    </ng-select>
  </ng-container>
  <ng-template #loading>{{t('Loading users')}}...</ng-template>
</ng-container>
